// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2ZqQd","containerItemsCenter":"Skeleton_containerItemsCenter__12LC-"};